"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalForm = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var UI_1 = require("../UI");
function useModalForm(_a) {
    var _this = this;
    var _b = _a.form, onSubmit = _b.onSubmit, onSuccess = _b.onSuccess, form = tslib_1.__rest(_b, ["onSubmit", "onSuccess"]), FormComponent = _a.FormComponent, modalProps = tslib_1.__rest(_a, ["form", "FormComponent"]);
    var _c = UI_1.useUIContext(), useForm = _c.useForm, useModal = _c.useModal;
    var formProps = tslib_1.__assign(tslib_1.__assign({}, form), { onSubmit: function (values, formikHelpers) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onSubmit(values, formikHelpers)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); }, onSuccess: function (data) {
            if (onSuccess) {
                onSuccess(data);
            }
            useModalResult.closeModal();
        }, closeModal: function () { return useModalResult.closeModal(); } });
    var formElement = FormComponent ? react_1.default.createElement(FormComponent, tslib_1.__assign({}, formProps)) : useForm(formProps);
    modalProps.children = formElement;
    var useModalResult = useModal(modalProps);
    return useModalResult;
}
exports.useModalForm = useModalForm;
//# sourceMappingURL=ModalForm.js.map